import React from 'react';
import { ModalDialog, ButtonBar } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';

interface FeedQuotaDialogProps {
  show: boolean;
  onClose: () => void;
}

const FeedQuotaDialog: React.FC<FeedQuotaDialogProps> = ({ show, onClose }) => {
  return (
    <ModalDialog
      show={show}
      title="Feed Limit Reached"
      closeButton="close"
      onClose={onClose}
    >
      <p>
        You've reached the maximum number of feeds for your current plan.
        Please unsubscribe from some feeds before adding new ones.
      </p>
      <ButtonBar className="full-margin-top" align="right">
        <TextButton type="major" onClick={onClose} label="OK" />
      </ButtonBar>
    </ModalDialog>
  );
};

export default FeedQuotaDialog;
